import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ReportCardComponent } from '../../add-note/report-card/report-card.component';
import { PottyNotesAlertController } from '../../error-handling/alerting/potty-notes-alert-controller';
import { NavigationHelper } from '../../helpers/navigation';
import { NoteService } from '../../services/note.service';
import { Subscription } from 'rxjs';
import { NavigationEventService } from '../../services/navigation-event.service';

@Component({
    selector: 'app-navigation-buttons',
    templateUrl: './navigation-buttons.component.html',
    styleUrls: ['./navigation-buttons.component.scss'],
    standalone: false
})
export class NavigationButtonsComponent implements OnInit, OnDestroy {
	@Input() isNextButtonDisabled = false;
	// When customizable guestbooks are implemented,
	// this variable needs to be controlled by utilizing: navigationHelper.isStartOfFlow()
	@Input() isBackButtonHidden = false;
	@Input() nextButtonText = "Next";
	@Input() skipButtonText = "Skip";
	@Input() isSkipButtonHidden = false;
	@Input() componentIdentifier: number;
	@Input() componentMetadata: any;
	@Input() isStartOfNoteFlow: boolean = false;
	@Input() isEndOfNoteFlow: boolean = false;
	@Input() twoButtonsShowing: boolean = false;
	@Input() isSkipDisplayed: boolean = false;

	@Output() successSubmit: EventEmitter<boolean> = new EventEmitter<boolean>();

	private navigationEventStateSubscription: Subscription | null = null;

	constructor(private navigationHelper: NavigationHelper,
		private noteService: NoteService,
		private router: Router,
		private pottyNotesAlertController: PottyNotesAlertController,
		private navigationEventStateService: NavigationEventService) { }

	ngOnDestroy(): void {
		if (this.navigationEventStateSubscription) {
			this.navigationEventStateService.unsubscribeFromPopState(this.navigationEventStateSubscription);
		}
	}

	ngOnInit(): void {
		this.navigationEventStateSubscription = this.navigationEventStateService.subscribeToPopState(({event, isBackNavigation}) => {
			if (isBackNavigation) {
				this.back();
			}
			else {
				this.continue();
			}
		});
	}

	public continue() {
		if (this.navigationHelper.isEndOfNoteFlow() && this.componentIdentifier == ReportCardComponent.ComponentIdentifier) {
			this.submitNote();
		} else {
			this.router.navigate([`${this.navigationHelper.getNextComponentUrl()}`]);
		}
	}

	public back() {
		this.router.navigate([`${this.navigationHelper.getPreviousComponentUrl()}`]);
	}

	public submitNote() {
		this.noteService.sendCreateNoteRequest().subscribe((response) => {
				this.successSubmit.emit(true);
			},
			(err) => {
				if (err.status == 403) {
					this.pottyNotesAlertController.displayForbiddenOnNoteSubmit();
				} else {
					this.pottyNotesAlertController.displaySubmitNoteFailure();
				}
			});
	}

	@ViewChildren('navigationButton') navigationButtons: QueryList<ElementRef>;
	getButtonElements(): Element[] {
	  return this.navigationButtons.map(button => button.nativeElement);
	}
}


